import * as actionTypes from "../../actionLabels/index";

const initialState = {
  englishauctiondata: [],
  userWiseViewEnglishAuctionData: [],
  loading: false,
  defaultColumnConfig: [],
  error: null,
  fetchEnglishAuctionCenterDataApiCall: false,
  englishcatelogFetchAllData: [],
  catelogAddData: [],
  lotWiseBidAcceptData: [],
  bidBook: [],
  bidBookExport: [],
  sessionTimeList: [],
  remainingsec: 60,
  lotdropdowndata: [],
  searchBidBookdropdownData: [],
  viewBidDataOnly: [],
  defaultSetColumndata: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ENGLISH_AUCTION_HEADER_DATA_SUCCESS:
      return {
        ...state,
        englishauctiondata: action.payload,
        error: null,
      };
    case actionTypes.FETCH_ENGLISH_AUCTION_HEADER_DATA_FAILURE:
      return {
        ...state,
        englishauctiondata: [],
        error: action.payload,
      };
    case actionTypes.VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_SUCCESS:
      return {
        ...state,
        userWiseViewEnglishAuctionData: action.payload,
        error: null,
      };
    case actionTypes.VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_FAILURE:
      return {
        ...state,
        userWiseViewEnglishAuctionData: [],
        error: action.payload,
      };
    case actionTypes.FETCH_ENGLISH_AUCTION_CENTER_DATA_API_CALL:
      return {
        ...state,
        fetchEnglishAuctionCenterDataApiCall: action.payload,
      };

    case actionTypes.FETCH_DEFAULT_COLUMN_CONFIG_SUCCESS:
      return {
        ...state,
        defaultColumnConfig: action.payload,
        error: null,
      };
    case actionTypes.FETCH_DEFAULT_COLUMN_CONFIG_FAILURE:
      return {
        ...state,
        defaultColumnConfig: [],
        error: action.payload,
      };
    case actionTypes.ENGLISH_CATELOG_FETCH_ALL_DATA_SUCCESS:
      return {
        ...state,
        englishcatelogFetchAllData: action.payload,
        error: "",
        errorMessage: "", // Reset the errorMessage field on time of success
      };

    case actionTypes.ENGLISH_CATELOG_FETCH_ALL_DATA_FAILURE:
      return {
        ...state,
        englishcatelogFetchAllData: "",
        error: action.payload,
        errorMessage: "Failed to fetch catelog data",
      };
    case actionTypes.ADD_CATALOG_COLUMN_CONFIG_SUCCESS:
      return {
        ...state,
        catelogAddData: action.payload,
        error: "",
      };
    case actionTypes.ADD_CATALOG_COLUMN_CONFIG_FAILURE:
      return {
        ...state,
        catelogAddData: "",
        error: action.payload,
        errorMessage: "Failed to submit",
      };

    case actionTypes.LOT_WISE_BID_ACCEPT_SUCCESS:
      return {
        ...state,
        loading: false,
        lotWiseBidAcceptData: action.payload,
        error: null,
      };
    case actionTypes.LOT_WISE_BID_ACCEPT_FAILURE:
      return {
        ...state,
        loading: false,
        lotWiseBidAcceptData: null,
        error: action.payload,
      };
    case actionTypes.FETCH_REMAINING_TIME_SUCCESS:
      return {
        ...state,
        remainingsec: action.payload,
      };
    case actionTypes.FETCH_REMAINING_TIME_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case actionTypes.FETCH_BID_BOOK_REQUEST:
      if (action.payload.isExport == 1) {
        return {
          ...state,
          loading: false,
        };
      } else {
        return {
          ...state,
          loading: true,
        };
      }

    case actionTypes.FETCH_BID_BOOK_SUCCESS:
      return {
        ...state,
        loading: false,
        bidBook: action.payload,
        error: null,
      };
    case actionTypes.FETCH_BID_BOOK_FAILURE:
      return {
        ...state,
        bidBook: [],
        error: action.payload,
      };
    case actionTypes.FETCH_SESSION_TIME_SUCCESS:
      return {
        ...state,
        sessionTimeList: action.payload,
        error: null,
      };
    case actionTypes.FETCH_SESSION_TIME_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case actionTypes.FETCH_LOT_SUCCESS:
      return {
        ...state,
        lotdropdowndata: action.payload,
        error: null,
      };
    case actionTypes.FETCH_LOT_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case actionTypes.FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_SUCCESS:
      return {
        ...state,
        searchBidBookdropdownData: action.payload,
        error: null,
      };
    case actionTypes.FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_FAILURE:
      return {
        ...state,
        searchBidBookdropdownData: [],
        error: action.payload,
      };
    case actionTypes.FETCH_BID_BOOK_EXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        bidBookExport: action.payload,
        error: null,
      };
    case actionTypes.FETCH_BID_BOOK_EXPORT_FAILURE:
      return {
        ...state,
        bidBookExport: [],
        error: action.payload,
      };
    case actionTypes.VIEW_BID_SUCCESS:
      return {
        ...state,
        viewBidDataOnly: action.payload,
        error: null,
      };
    case actionTypes.VIEW_BID_FAILURE:
      return {
        ...state,
        viewBidDataOnly: [],
        error: action.payload,
      };
    case actionTypes.ADD_CATALOG_COLUMN_CONFIG_COMPLETE:
      return { ...state, defaultSetColumndata: action.payload };

    case actionTypes.ADD_CATALOG_COLUMN_CONFIG_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default reducer;
